import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { TeliaHeader } from 'telia-navigation';

import { urlLanguage } from 'apollo';
import Logo from 'components/custom/logo/Logo';
import { generateLinksWithSections } from 'components/voca/the-header/transformers';
import { useTranslatedUrlContext } from 'contexts/translatedUrl.context';
import { URL_LANGUAGE_ENUM } from 'utils/constants';
import useNavigationSearch from 'utils/hooks/useNavigationSearch';

import 'components/voca/the-header/TheHeader.scss';

export default function TheHeader() {
  const { t } = useTranslation();
  const { navigateToTranslatedUrl } = useTranslatedUrlContext();

  const { suggestions, setSearchQuery, onSearch } = useNavigationSearch();

  return (
    <div className="the-header">
      <TeliaHeader
        links={generateLinksWithSections(urlLanguage())}
        i18n={i18n}
        onSearch={onSearch}
        isSticky
        selectedLanguage={urlLanguage()}
        availableLanguages={Object.values(URL_LANGUAGE_ENUM)}
        onLanguageChange={(lang) => navigateToTranslatedUrl(lang as URL_LANGUAGE_ENUM)}
        logo={<Logo />}
        handleSearchInput={setSearchQuery}
        searchSuggestions={suggestions}
        searchPlaceholder={`${t('actions.search')}...`}
      />
    </div>
  );
}
